import gql from 'graphql-tag';

import integrationItemFragment from '../fragments/integrationItemFragment';

export default gql`
  query integrationItem(
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    integrationItem(
      integrationID: $integrationID
      remoteID: $remoteID
    ) {
      ...integrationItemFragment
    }
  }
  ${integrationItemFragment}
`;
